import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { SearchNavbarBaseSubformComponent } from '@shared/components/search-layout/search-navbar/search-navbar-base-subform/search-navbar-base-subform.component';

@Component({
  selector: 'app-text-input-subform',
  templateUrl: './text-input-subform.component.html',
  styleUrls: ['./text-input-subform.component.scss'],
})
export class TextInputSubformComponent extends SearchNavbarBaseSubformComponent {
  @Input() override data?: {
    type?: 'text' | 'number';
    maxDecimals?: number;
  };

  override group = this.fb.group({
    text: new UntypedFormControl(null, []),
  });

  override updateValue(filter?: any): void {
    this.clear();
    if (filter && filter[this.property]) {
      this.group.controls['text'].setValue(filter[this.property]);
      this.valueChanged(filter[this.property]);
    }
    if (!filter) {
      this.clear();
    }
  }

  valueChanged(event?: string): void {
    this.store.dispatch(
      this.filterUpdater.trigger({
        filter: {
          [this.property]: event,
        },
      })
    );
  }

  override clear(): void {
    this.group.reset();
    this.valueChanged(undefined);
  }
}
